import { API_URL } from '../circulusConfig';
import { encodeGetParams, getHeaders } from '../common/util';
import { PUT } from '../common/consts';

// 음성 데이터 목록 가져오기
const getUserDiaryAPI = async (data) => {
  const res = await fetch(`${API_URL}diary?${encodeGetParams(data)}`);
  const result = res.json();
  return result;
};
// 음성 삭제
const deleteDiaryAPI = async (data) => {
  const res = await fetch(`${API_URL}diary`, getHeaders(PUT, { ...data }));
  const result = res.json();
  return result;
};
export { getUserDiaryAPI, deleteDiaryAPI };
